var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 16.5,
    viewBox: "0 0 16.5 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Retire_icon",
    "data-name": "Retire icon",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_977",
    "data-name": "Rectangle 977",
    width: 1.176,
    height: 12.644,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 3.114, 3.944)",
    fill: "#b47714",
    stroke: "#b47714",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_978",
    "data-name": "Rectangle 978",
    width: 12.643,
    height: 1.175,
    transform: "translate(3.114 12.055) rotate(-45)",
    fill: "#b47714",
    stroke: "#b47714",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M350.253,246.38a8,8,0,1,1,8-8A8.01,8.01,0,0,1,350.253,246.38Zm0-15.007a7.006,7.006,0,1,0,7.006,7.005A7.012,7.012,0,0,0,350.253,231.373Z",
    transform: "translate(-342.254 -230.38)",
    fill: "#b47714",
    stroke: "#b47714",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetire);
export default __webpack_public_path__ + "static/media/retire.536531bf24b0f32c8d3ca4c2fea38dac.svg";
export { ForwardRef as ReactComponent };